import { DateTime } from 'luxon'
import { EventItem } from 'Types/emajinAPI'

type StateCode = 'NSW' | 'QLD' | 'VIC'
const STATE_ORDER: StateCode[] = ['NSW', 'QLD', 'VIC']

function isUpcoming(date?: string | null, now = DateTime.utc()): boolean {
  if (!date) return false
  const dateTime = DateTime.fromISO(date, { setZone: true })
  return dateTime.isValid && dateTime.toUTC() >= now
}

export function getNextEventsByState(items: EventItem[]) {
  const upcomingItems = items.filter(
    item =>
      STATE_ORDER.includes(item.location as StateCode) && isUpcoming(item.date),
  )

  const groupedItems = upcomingItems.reduce<Record<StateCode, EventItem[]>>(
    (acc, item) => {
      acc[item.location as StateCode].push(item)
      return acc
    },
    { NSW: [], QLD: [], VIC: [] },
  )

  const pickEarliest = (list: EventItem[]) =>
    list.length === 0
      ? null
      : list
          .slice()
          .sort(
            (a, b) =>
              DateTime.fromISO(a.date!, { setZone: true }).toUTC().toMillis() -
              DateTime.fromISO(b.date!, { setZone: true }).toUTC().toMillis(),
          )[0]

  return [
    pickEarliest(groupedItems.NSW),
    pickEarliest(groupedItems.QLD),
    pickEarliest(groupedItems.VIC),
  ].filter((item): item is EventItem => item !== null)
}
